import axiosBase from "../axiosBase";

export const apiLoadTechnologiesMain = () =>
  axiosBase.get("block/page/main?parent=technologiesMain");
export const apiLoadTechnologiesBlock = () => axiosBase.get("technology/");
